import services from './_services'

export default {
  getStartupResources (params) {
    return services.getWithParams(process.env.ROOT_API + '/startup_resources', params)
  },
  getStartupResource (id) {
    return services.get(process.env.ROOT_API + '/startup_resources/' + id)
  },
  createResource (resourceObject) {
    return services.post(process.env.ROOT_API + '/startup_resources/', resourceObject)
  },
  uploadLogoToResource (id, logoObject) {
    return services.post(process.env.ROOT_API + '/startup_resources/' + id + '/upload', logoObject)
  },
  updateResource (resourceObject) {
    return services.put(process.env.ROOT_API + '/startup_resources/', resourceObject)
  },
  addTagToResource (resourceId, tagId) {
    return services.post(process.env.ROOT_API + '/startup_resources/' + resourceId + '/tag/' + tagId, {})
  },
  removeTagFromResource (resourceId, tagId) {
    return services.deleteCall(process.env.ROOT_API + '/startup_resources/' + resourceId + '/tag/' + tagId)
  },
  searchTags (resourceId, tagName) {
    return services.getWithParams(process.env.ROOT_API + '/startup_resources/tag', {name: tagName, resource_id: resourceId})
  }
}



// WEBPACK FOOTER //
// ./src/api/startupResources.js